import { SchoolType } from './enums';

export const SCHOOL_TYPES = Object.values(SchoolType).map(type => ({
  value: type,
  label: type,
}));

const listAttributes = [
  'schoolId',
  'label',
  'shortLabel',
  'abbreviation',
  'type',
  'hscRank',
  'address',
] as const;

const searchAttributes = ['label', 'shortLabel', 'abbreviation'] as const;

const updateAttributes = [
  'label',
  'shortLabel',
  'abbreviation',
  'type',
  'hscRank',
  'address',
] as const;

// Optional attributes that an update may unset by sending null
const removableAttributes = ['abbreviation', 'hscRank'] as const;

export const SchoolAttributes = {
  List: listAttributes,
  Get: listAttributes,
  Search: searchAttributes,
  Update: updateAttributes,
  Removable: removableAttributes,
};
